import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LeagalServiceService {

  private baseUrl:string = `${environment.legalAssureApiBaseUrl}`;

  constructor(private httpClient:HttpClient) { }

  createService(request:any){
    return this.httpClient.post<any[]>(this.baseUrl+'service',request);

  }

  getAllServices(): Observable<any[]> {
   let headersOptions = new HttpHeaders();
   headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl+'service',{headers:headersOptions});
  }
  deleteById(data:any){
    return this.httpClient.delete<any[]>(this.baseUrl+`service/${data}`);
  }

  getById(data:any){
    return this.httpClient.get<any>(this.baseUrl+`service/${data}`);
  }
  updateClient(request:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any[]>(this.baseUrl+'service',request);
  }

  saveQuotationConfiguration(request: any) {
    return this.httpClient.post<any>(this.baseUrl + 'Quotation/configuration', request);
  }

  getQuotationConfigurationByServiceId(serviceId: string) {
    return this.httpClient.get<any>(this.baseUrl + `Quotation/configuration/service/${serviceId}`);
  }

  updateQuotationConfiguration(id: number | string, request: any) {
    return this.httpClient.put<any>(this.baseUrl + `Quotation/configuration/${id}`, request);
  }

  saveGeneratedQuotation(request: any[]) {
    return this.httpClient.post<any>(this.baseUrl + 'Quotation/service-details', request);
  }

  getQuotationServiceDetails(quotationId: number) {
    return this.httpClient.get<any[]>(this.baseUrl + `Quotation/service-details/quotation/${quotationId}`);
  }
  

  getServiceGroup(){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl+'service/GetServiceGroup');
  }

  getServicesByGroupId(id:string){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl+`service/GetServicesByGroupId/${id}`);
  }

  updateClientServiceOwner(request:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.put<any>(this.baseUrl+`service/UpdateClientServiceOwner`,request);
  }

  getServiceDescription(id:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl+`service/GetServiceDescription/${id}`);
  }

   createServiceTask(data:any,serviceId:string){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.post<any>(this.baseUrl+`service/ServiceTask/${serviceId}`,data);
  }

    getServiceTaskById(data:any){
    let headersOptions = new HttpHeaders();
    headersOptions = headersOptions.set('Content-Type', 'application/json; charset=utf-8');
    return this.httpClient.get<any[]>(this.baseUrl+`service/ServiceTask/${data}`);
  }

   deleteServicetaskById(data:any){
    return this.httpClient.delete<any[]>(this.baseUrl+`service/ServiceTask/${data}`);
  }

    updateServicetaskStatus(id:string,isEnabled:boolean){
    return this.httpClient.get<any[]>(this.baseUrl+`service/UpdateServiceTaskStatus/${id}/${isEnabled}`);
  }

  
}
